import styled from 'styled-components';

export const SelectComplementsContainer = styled.div`
  width: 100%;
  display: flex;
`;
